import React from 'react';

import { AlertProps, IconButton, useTheme } from '@mui/material';

import { CheckmarkIcon, CrosshairIcon, WarningIcon } from '~/components/icons';

import { CustomAlert } from './styled';

interface IAlertProps extends AlertProps {
  message: React.ReactNode;
}

export const Alert: React.FC<IAlertProps> = (props) => {
  const { message, severity, onClose, ...others } = props;

  const { palette } = useTheme();

  const Icon =
    severity === 'success'
      ? CheckmarkIcon
      : severity === 'warning' || severity === 'error'
        ? WarningIcon
        : null;

  return (
    <CustomAlert
      {...others}
      severity={severity}
      onClose={onClose}
      action={
        <IconButton onClick={onClose}>
          <CrosshairIcon
            sx={{
              color: palette.text.secondary,
              fontSize: 14,
              transform: 'rotate(45deg)',
            }}
          />
        </IconButton>
      }
      icon={
        Icon ? (
          <Icon sx={{ color: palette.primary.contrastText, fontSize: 20 }} />
        ) : null
      }
    >
      {message}
    </CustomAlert>
  );
};
